import { X, Check, ShieldCheck } from "lucide-react";
import { Chapter, Reveal } from "./Shared";

const GENERIC = ["Sold to 2,000+ sellers", "No exclusivity", "Your competitor has the same file"];
const YOURS = ["Created for your brief", "Your niche and style", "Reserved for your shop", "Never resold to another seller"];

export default function ExclusivitySection() {
  return (
    <section id="exclusivity" data-testid="exclusivity-section" className="relative">
      <div className="mx-auto max-w-5xl px-6 py-16 sm:py-20">
        <Reveal className="text-center">
          <Chapter num="05" label="Exclusivity" className="justify-center" />
          <h2 className="mx-auto mt-6 max-w-3xl text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Your Design Doesn't Become Everyone Else's Design.
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-2">
          <Reveal delay={0.08}>
            <div
              data-testid="exclusivity-generic-card"
              className="h-full rounded-3xl border border-rose-400/20 bg-[#070B14]/70 p-7"
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-rose-300">
                Generic Marketplace Asset
              </p>
              <ul className="mt-6 space-y-4">
                {GENERIC.map((g) => (
                  <li key={g} className="flex items-start gap-3 text-[15px] text-slate-400">
                    <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-rose-400/30 bg-rose-500/10">
                      <X className="h-3 w-3 text-rose-400" />
                    </span>
                    {g}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.16}>
            <div
              data-testid="exclusivity-grapho-card"
              className="h-full rounded-3xl border border-amber-400/30 bg-gradient-to-b from-[#1A1408]/80 to-[#070B14]/70 p-7"
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber-300">
                Your Grapho Design
              </p>
              <ul className="mt-6 space-y-4">
                {YOURS.map((y) => (
                  <li key={y} className="flex items-start gap-3 text-[15px] font-medium text-slate-100">
                    <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-400/15">
                      <Check className="h-3 w-3 text-emerald-400" />
                    </span>
                    {y}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div
            data-testid="exclusivity-callout"
            className="mt-10 rounded-r-2xl border-l-4 border-amber-400 bg-[#0A1020]/90 px-6 py-5 text-left shadow-[0_14px_44px_rgba(0,0,0,0.38)]"
          >
            <div className="flex items-start gap-3">
              <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-amber-300" />
              <p className="text-sm font-medium leading-relaxed text-slate-200 sm:text-[15px]">
                Most POD sellers buy trending designs from Etsy marketplaces — the same files sold to
                dozens or hundreds of other shops. That shared design kills your uniqueness and floods
                your niche with identical listings. Grapho creates every design exclusively for your
                account, cross-checks it against US trademarks, and never shows, shares, or sells it to
                any other seller.{" "}
                <span className="font-semibold text-amber-300">
                  Your designs are your competitive edge — protected.
                </span>
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <p
            data-testid="exclusivity-tagline"
            className="mt-6 text-center text-sm italic tracking-wide text-slate-400"
          >
            Don't copy the trend. Capture the opportunity.
          </p>
        </Reveal>
      </div>
    </section>
  );
}